import React from "react";

export default function FilteredContentWrapper({children, width}) {

    return (
        <div style={{height: "inherit", minWidth: width, width: width}}>
            {children}
        </div>
    );
}
